import { SimpleAppender } from "@components/admin/admin-helpers"
import { defineBlock, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Contents",
  tags: ["film-text"],
  icon: "welcome-write-blog",
  description: "Contains the written content, info, and session info for a film.",
  category: "Film",
  inserter: false,
}

/**
 * Developer note: This component is only rendered in the editor! Not the frontend.
 */

export default defineBlock("film/film-contents", (props) => {
  return (
    <div className="grid-auto">
      <div className="cols-film-main">
        <InnerBlocks
          defaultBlocks={[
            ["film/film-long-description", {}],
            ["film/film-guests", {}],
            ["film/film-note", {}],
            ["film/film-hierarchy", {}],
            ["film/film-tickets", {}],
          ]}
          allowedBlocks={["film-text", "richtext", "subpage"]}
          appender={SimpleAppender}
          adminClassName="flex flex-col gap-3"
        />
      </div>
    </div>
  )
})
